function Upload({ fill = "#2E384D" }) {
  return (
    <svg width="26" height="21" viewBox="0 0 26 21" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
        <path
          d="M1.61802 10.2131C2.00964 10.2131 2.32293 10.501 2.32293 10.8608V16.7519C2.32293 18.3542 3.74319 19.6542 5.48197 19.6542H20.9482C22.6922 19.6542 24.1073 18.3494 24.1073 16.7519V10.7648C24.1073 10.405 24.4206 10.1172 24.8122 10.1172C25.2038 10.1172 25.5171 10.405 25.5171 10.7648V16.7519C25.5171 19.069 23.465 20.9495 20.9482 20.9495H5.48197C2.95996 20.9495 0.913109 19.0642 0.913109 16.7519V10.8608C0.913109 10.5058 1.2264 10.2131 1.61802 10.2131Z"
          fill={fill}
        />
        <path
          d="M17.199 5.22427L13.9199 2.21156V15.3514C13.9199 15.7112 13.6066 15.999 13.215 15.999C12.8234 15.999 12.5101 15.7112 12.5101 15.3514V2.21156L9.23093 5.22427C9.09517 5.349 8.91242 5.41616 8.73488 5.41616C8.55213 5.41616 8.3746 5.35379 8.23884 5.22427C7.96209 4.97001 7.96209 4.56224 8.23884 4.30798L12.7189 0.191892C12.8495 0.0719596 13.0322 0 13.215 0C13.403 0 13.5805 0.0671623 13.711 0.191892L18.1911 4.30798C18.4679 4.56224 18.4679 4.97001 18.1911 5.22427C17.9196 5.47373 17.4705 5.47373 17.199 5.22427Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default Upload;
